if (!window.__rsmTrackingBound) {
  window.__rsmTrackingBound = true;
  window.addEventListener('click', function (evt) {
    if (evt.target.closest('.rsm-trigger')) {
      window.igEvents = window.igEvents || [];
      window.igEvents.push({ event: 'cat_lp_see_review_summary_clicked' });
    }
  });
}

function rsmInit(sectionId) {
  var overlay = document.getElementById('rsm-overlay-' + sectionId);
  var openBtn = document.getElementById('rsm-open-' + sectionId);
  var closeBtn = document.getElementById('rsm-close-' + sectionId);

  if (!overlay || !openBtn || !closeBtn) return;

  function openModal() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    openBtn.focus();
  }

  openBtn.addEventListener('click', openModal);
  closeBtn.addEventListener('click', closeModal);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeModal();
    }
  });
}

function rsmInitAll() {
  document.querySelectorAll('[data-rsm-section]:not([data-rsm-initialized])').forEach(function (el) {
    el.setAttribute('data-rsm-initialized', 'true');
    rsmInit(el.dataset.rsmSection);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', rsmInitAll);
} else {
  rsmInitAll();
}
